var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"awardContainer",style:(_vm.bgStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }